import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

export function useWorkshops() {
  return useQuery({
    queryKey: ['workshops'],
    queryFn: async () => {
      const res = await api.get('/workshops');
      return res.data;
    },
    staleTime: 60 * 1000,
  });
}

export function useApproveWorkshop() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.post(`/workshops/${id}/approve`).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['workshops'] });
      qc.invalidateQueries({ queryKey: ['companies'] });
      qc.invalidateQueries({ queryKey: ['practice-metrics'] });
    },
  });
}

export function useDenyWorkshop() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }) => api.post(`/workshops/${id}/deny`, { reason }).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['workshops'] }),
  });
}

export function useBackfillCalendarLinks() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post('/workshops/backfill-calendar-links').then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['workshops'] }),
  });
}

export function useUpdateBilling() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }) => api.put(`/clients/${id}/billing`, data).then((r) => r.data),
    onSuccess: (_, { id }) => {
      qc.invalidateQueries({ queryKey: ['clients', id] });
    },
  });
}
